import { ThunkAction } from 'redux-thunk';
import * as Bixby from './../../core';
import { AppState } from './..';
import { MsalService } from './../../services';

import { MSAL_LOGIN_INPROGRESS, MSAL_LOGIN_SUCCESS, MSAL_LOGIN_FAILURE, MSAL_LOGOUT_SUCCESS } from './types';

// action creators
export const msalLoginInProgress = () => {
  return {
    type: MSAL_LOGIN_INPROGRESS,
  };
};

export const msalLoginSuccess = () => {
  return {
    type: MSAL_LOGIN_SUCCESS,
    payload: true,
  };
};

export const msalLoginFailure = (error: Bixby.Models.BixbyError) => {
  return {
    type: MSAL_LOGIN_FAILURE,
    payload: error,
    error: true,
  };
};

export const msalLogoutSuccess = () => {
  return {
    type: MSAL_LOGOUT_SUCCESS,
    payload: {},
  };
};

// thunk actions
export const msalStandAloneLogin = (): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => {
  return async dispatch => {
    dispatch(msalLoginInProgress());
    try {
      await MsalService.loginAsync();
      dispatch(msalLoginSuccess());
    } catch (error: any) {
      dispatch(msalLoginFailure(error));
    }
  };
};

export const msalIframeLogin = (): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => {
  return async dispatch => {
    dispatch(msalLoginInProgress());
    MsalService.msalInIframeLogin();
  };
};

export const msalLogout =
  (): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => async dispatch => {
    MsalService.logout();
    dispatch(msalLogoutSuccess());
  };

export const resumeFromMsalCache =
  (): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => async dispatch => {
    const resumeFromCache = MsalService.resumeFromCache();
    if (resumeFromCache) {
      dispatch(msalLoginSuccess());
    }
  };
